import React from 'react';
import * as Colors from 'material-ui/styles/colors';

import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import iconPath from 'shared/icons';
export default (props) => {
  return (
    <CustomSvgIcon color={Colors.grey700} path={iconPath.viewGrid} {...props}/>
  );
};
